
import { createReducer } from '@reduxjs/toolkit';
import { IFacilityProfileState } from './types';
import { fetchFacilityProfile } from './actions';

const initialState: IFacilityProfileState = {
  loading: false,
  data: null,
  error: null,
};

export const facilityProfileReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(fetchFacilityProfile.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchFacilityProfile.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    })
    .addCase(fetchFacilityProfile.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});
